import { gql } from '@apollo/client';

export const ordersGql = gql`
  query Orders(
    $personId: ID!
    $initialRow: Int!
    $nextRows: Int!
    $statusSciaIs: String!
    $purchaseOrderId: ID
    $productId: ID
    $numericCode: String
    $productName: String
    $branchId: ID
    $finalIssueDate: String
    $finalScheduleDate: String
    $initialIssueDate: String
    $initialScheduleDate: String
    $GEPDescription: Int
    $divisionId: Int
    $familyId: Int
  ) {
    Orders(
      personId: $personId
      initialRow: $initialRow
      nextRows: $nextRows
      statusSciaIs: $statusSciaIs
      purchaseOrderId: $purchaseOrderId
      productId: $productId
      numericCode: $numericCode
      productName: $productName
      branchId: $branchId
      finalIssueDate: $finalIssueDate
      finalScheduleDate: $finalScheduleDate
      initialIssueDate: $initialIssueDate
      initialScheduleDate: $initialScheduleDate
      GEPDescription: $GEPDescription
      divisionId: $divisionId
      familyId: $familyId
    ) {
      purchaseOrderId
      productId
      numericCode
      productName
      colorAbbreviation
      issueDate
      deliveryDate
      scheduleDate
      sciaStatusDescription
      branchId
      deliveryDateOrigin
      totalRows
    }
  }
`;
